import React from "react";
import { useTranslation } from "react-i18next";

// BlockGuide — the "Why choose us" feature grid.
// Self-contained: ships its own grid + styles (scoped CSS variables), so
// it no longer depends on being wrapped in a Bootstrap `.row` with
// `.col-lg-3` siblings. If you reuse it elsewhere, just drop
// `<WhyChoose />` directly inside a `.container` — no wrapping row needed.
const BlockGuide = () => {
  const { t } = useTranslation();

  const blockContent = [
    {
      id: 1,
      icon: "/img/featureIcons/3/1.svg",
      title: t("bestPriceGuarantee"),
      text: t("bestPriceGuaranteeText"),
    },
    {
      id: 2,
      icon: "/img/featureIcons/3/2.svg",
      title: t("easyQuickBooking"),
      text: t("easyQuickBookingText"),
    },
    {
      id: 3,
      icon: "/img/featureIcons/3/4.svg",
      title: t("customerCare247"),
      text: t("customerCare247Text"),
    },
    {
      id: 4,
      icon: "/img/featureIcons/3/3.svg",
      title: t("handpickedDestinations"),
      text: t("handpickedDestinationsText"),
    },
  ];

  return (
    <div className="why-choose-grid">
      <style>{`
        .why-choose-grid {
          --wc-teal: #294b5a;
          --wc-gold: #d3be76;
          --wc-gold-d: #b09a50;
          --wc-cream: #f7f4ee;
          --wc-silver: #7c8b94;
          --wc-ink: #1a2f38;

          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 28px;
          width: 100%;
        }
        @media (max-width: 991px) {
          .why-choose-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 560px) {
          .why-choose-grid { grid-template-columns: 1fr; }
        }

        .why-choose-card {
          position: relative;
          background: var(--wc-cream);
          border: 1px solid rgba(41, 75, 90, 0.08);
          border-radius: 16px;
          padding: 38px 26px 32px;
          text-align: center;
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease, background 0.3s ease;
        }
        .why-choose-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 3px;
          background: linear-gradient(90deg, var(--wc-teal) 0%, var(--wc-gold) 100%);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.4s ease;
        }
        .why-choose-card:hover {
          background: #fff;
          transform: translateY(-6px);
          box-shadow: 0 22px 50px rgba(26, 49, 64, 0.12);
          border-color: rgba(211, 190, 118, 0.4);
        }
        .why-choose-card:hover::before {
          transform: scaleX(1);
        }

        .why-choose-card__icon-wrap {
          width: 68px;
          height: 68px;
          margin: 0 auto 22px;
          border-radius: 50%;
          background: #fff;
          border: 1px solid rgba(211, 190, 118, 0.35);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.3s ease, transform 0.3s ease;
        }
        .why-choose-card:hover .why-choose-card__icon-wrap {
          background: var(--wc-gold);
          transform: scale(1.06);
        }
        .why-choose-card__icon-wrap img {
          width: 30px;
          height: 30px;
        }

        .why-choose-card__title {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          font-weight: 600;
          color: var(--wc-ink);
          margin: 0 0 10px 0;
        }
        .why-choose-card__text {
          font-family: 'DM Sans', sans-serif;
          font-size: 13.5px;
          line-height: 1.7;
          font-weight: 300;
          color: var(--wc-silver);
          margin: 0;
        }
      `}</style>

      {blockContent.map((item) => (
        <div className="why-choose-card" key={item.id}>
          <div className="why-choose-card__icon-wrap">
            <img src={item.icon} alt="" className="js-lazy" />
          </div>
          <h4 className="why-choose-card__title">{item.title}</h4>
          <p className="why-choose-card__text">{item.text}</p>
        </div>
      ))}
    </div>
  );
};

export default BlockGuide;